// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023investigate/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const loginInfo = (data:any) => {
  return http.post(`${urlPrefix}login`,qs.stringify(data));
};

const getList= () => {
  return http.get(`${urlPrefix}answer-list`);
};

const saves= (data:any) => {
  return http.post(`${urlPrefix}answer`,qs.stringify(data));
};
export { getBaseInfo,loginInfo ,getList,saves };
